import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';

//import { TranslateComponent } from '../translate/translate.component';

import *  as $ from 'jquery';
import * as backInter from 'app/auth/auth-data.model';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import { ForAllService } from 'app/main/wizard-cgo/services/forall.service';


import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import Swal from 'sweetalert2';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

import { BroadcastService } from '../broadcast.service';
import { BroadcastTranslateService } from '../broadcasttranslate.service';
import { TranslateServiceApi } from "../services/translate.service";
interface adverModal {
  tipo: number;
  mensaje: string;
  diccionario: string;
  confirma: boolean;
};

@Component({
    selector     : 'forAllTabs',
    templateUrl  : './forAllTabs.component.html',
    styleUrls    : ['./forAllTabs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class ForAllTabsComponent implements OnInit  {

  // Datos certificar vigente
  productoCertificar: backInter.prodCert;
  //boolean paso completo
  pasoCompleto = false;

  practicasLlenas = false;

  numArrayTraduc: number = 0;

  steps = [
        {
        'id': 'idiomas',
        'title'  : 'WIZARD.CERTIFICAR.STEPS.STP1.WIZBT',
        'content': '',
        'icon' : 'language',
        'ruta' : './native',
        'tituloPagina': 'WIZARD.CERTIFICAR.STEPS.STP1.TITULO',
        'subtiPagina': 'WIZARD.CERTIFICAR.STEPS.STP1.SUBTI',
        'status' : 0
    },
    ];
    course = {
          'id'         : '15459251a6d6b397565',
          'title'      : 'Certificar',
          'slug'       : 'cgo-certificar',
          'description': 'Commits that need to be pushed lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          'category'   : 'CGO',
          'length'     : 30,
          'totalSteps' : 4,
          'updated'    : '9 Agosto 2019',
          'steps'      : this.steps,
          'tagTrad': 'WIZARD.CERTIFICAR.TITULO'
      };

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    public dialog: MatDialog,
    private translateService: TranslateServiceApi,
    private forallService: ForAllService,

    private wizardService: WizardService,
    private broadcast: BroadcastService,
    private broadcasttranslate: BroadcastTranslateService,
    private translateSrv: TranslateService
  )
  {
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }
  ngOnInit() {
    $(document).ready(function(){
      $(".finishBt").width($(".finishBt").parent().width());
    });
    $(window).resize(function(){
      $(".finishBt").width($(".finishBt").parent().width());
    });

    this.obtieneCertificarActual();
  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.forallService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaCertificar;
            let idProducto = producto.idCertificar;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){

              this.productoCertificar = producto;
              console.log("Producto");
              console.log(this.productoCertificar);
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.forallService.getStatusForAll(parseInt(localStorage.getItem('fechaProducto'))).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3)
          this.pasoCompleto = true;
      });

      this.getStatusModal();
      //obtiene las preguntas adicionales guardadas
    }, error  => {
      //console.log("error al recuperar certificar vigente");
    });
  }

  getStatusModal(){
    let datos={
      fechaCertificar: this.productoCertificar.fechaCertificar,
      forall: 1
    };
    //console.log(datos);
    this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
      console.log("For all questions");
      console.log(data);
      if(data.estatus==1){

            this.modalInformativo('FORALL');
      }
    });
  }

  updateStatusModal(){
    let datos={
      fechaCertificar: this.productoCertificar.fechaCertificar,
      forall: 2
    };
    // console.log(datos);
    this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  getNumTraducciones(status:boolean){
    if(status){
      console.log("entró a actualizar num traducciones");

      let data = {fechaCertificar: localStorage.getItem('fechaProducto')};
      this.forallService.getPracticesSaved(data).subscribe(response => {
        console.log(response);

        let status = response['message'];
        if(status == 200){
          this.translateService.getLanguajesListSelected(data).subscribe(response => {
            console.log(response);
            this.numArrayTraduc = response['idiomasMostrar'].length;
          });

        }


      }, error => {
        console.log("error", error);
      });
    }
  }

  sendBroadcast(indexTab){
    indexTab = indexTab['index'];
    if(indexTab == 1){
      // send product data to subscribers via observable subject
      this.broadcast.sendEvent();
    }else if(indexTab == 2){
      // send product data to subscribers via observable subject
      this.broadcasttranslate.sendEvent();
    }
  }
  translateGet:any;
  response:any;
  flagMensaje: boolean = false;
  completarPaso(){
    this.getPracticesSaved();
    //this.aletaRestric('FORALL.COMPLETAR',true);



    /*if(this.pasoCompleto){
      this.aletaRestric('FORALL.COMPLETADO',null,'warning');
    }else{
      if(this.practicasLlenas){
        this.aletaRestric('FORALL.COMPLETAR',true);
      }else{
        this.aletaRestric('FORALL.NADA',null,'warning');
      }
    } */

  }
  // Bandera temporal
  course_flag: any[];
  idiomasAdicionales: any;
  practicasNum:any;
  validacionCorrecta=0;
  idiomaTotal:any;
  private getPracticesSaved(){
    let data = {"fechaCertificar": localStorage.getItem('fechaProducto')};
    this.forallService.getPracticesSaved(data)
      .subscribe(response => {
        let status = response['message'];
        if(status == 200){

            this.course_flag = response['practicas'];
            let flag = response['practicas'];
            //this.getLanguajesList();
            //Prueba
            let data = {
              fechaCertificar:localStorage.getItem('fechaProducto')
            };
            this.translateService.getLanguajesListSelected(data)
              .subscribe(response => {
                // Información para traducciones
                this.practicasNum = localStorage.getItem('numPracticas');

                if(this.course_flag.length != this.practicasNum){
                  this.aletaRestric('FORALL.NADA',null,'warning'); // Falta descripción
                }

                let res2 = [];
                if(response['idiomasMostrar'].length > 0){
                  this.flagMensaje = true;
                }else{
                  //this.aletaRestric('FORALL.COMPLETAR',true);
                  if(this.course_flag){
                    if(this.course_flag.length==5 || this.course_flag.length == this.practicasNum){
                      let cont1=0;
                      let cont2=0;
                      for(let x=0; x < this.course_flag.length; x++){
                        this.translateGet = this.course_flag['traducciones'];
                        if(this.course_flag[x]['practicaForall'] != null && this.course_flag[x]['descripcionForall'] != null){
                          cont1++;
                        }
                      }
                      if(cont1==this.course_flag.length){
                        this.aletaRestric('FORALL.COMPLETAR',true);
                      }else{
                        this.aletaRestric('FORALL.NADA',null,'warning'); // Falta descripción
                      }
                    }else{
                      this.aletaRestric('FORALL.NADA',null,'warning'); // Falta descripción
                    }

                  }else{
                    this.aletaRestric('FORALL.NADA',null,'warning'); // Falta descripción
                  }
                }
                console.log("Dude idiomas");
                console.log(response['idiomasMostrar']);
                for (let i = 0; i < response['idiomasMostrar'].length; i++) {
                  let res = [];
                  for (let j = 0; j < this.course_flag.length; j++) {
                    let aux = 0;
                    let pract = '';
                    let desc = '';
                    this.translateGet = this.course_flag[j]['traducciones'];
                    aux = this.filterArray(response['idiomasMostrar'][i]['_id']);
                    if(aux != null){
                      if(this.translateGet[aux]['practicaForall'] != null){
                        pract = this.translateGet[aux]['practicaForall'];
                      }

                      if(this.translateGet[aux]['descripcionForall'] != null){
                        desc = this.translateGet[aux]['descripcionForall'];
                      }
                      res.push({'idPractica':this.course_flag[j]['_id'],'practNativo':this.course_flag[j]['practicaForall'],'descNativo':this.course_flag[j]['descripcionForall'],
                        'lenguaje':response['idiomasMostrar'][i]['nombreIdioma'],
                        'id':response['idiomasMostrar'][i]['_id'],
                        'practice':pract,
                        'description':desc});

                    }else{
                      res.push({'idPractica':this.course_flag[j]['_id'],'practNativo':this.course_flag[j]['practicaForall'],'descNativo':this.course_flag[j]['descripcionForall'],
                      'lenguaje':response['idiomasMostrar'][i]['nombreIdioma'],
                      'id':response['idiomasMostrar'][i]['_id'],
                      'practice':'',
                      'description':''});

                    }
                  }

                  res2.push({'nombreIdioma': response['idiomasMostrar'][i]['nombreIdioma'],
                      'tipoIdioma': response['idiomasMostrar'][i]['tipoIdioma'],
                      'vivoIdioma': response['idiomasMostrar'][i]['vivoIdioma'],
                      '_id': response['idiomasMostrar'][i]['_id'],
                      'arreglo':res});

                }

                this.response = res2;
                this.idiomasAdicionales = response['idiomasMostrar'];
                //let flag_tamanio=this.response.arreglo;

                for(let m=0; m< this.response.length; m++){
                  let arrayTmp_traducciones=this.response[m].arreglo;
                  for(let n=0; n<arrayTmp_traducciones.length;n++){
                    if(arrayTmp_traducciones[n].description.length > 0 && arrayTmp_traducciones[n].practice.length > 0){
                      this.validacionCorrecta++;
                    }
                  }

                  if(this.validacionCorrecta == this.response[m].arreglo.length){
                    console.log("Todo correcto nueva validación");
                    this.validacionCorrecta=0;
                    this.idiomaTotal++;

                  }else{
                    this.validacionCorrecta=0;
                  }
                }

                if(this.response.length == this.idiomaTotal){
                  this.idiomaTotal=0;
                  this.aletaRestric('FORALL.COMPLETAR',true);
                }else{
                  this.idiomaTotal=0;
                  this.aletaRestric('FORALL.NADA_TRA',null,'warning');
                }


                let flag_tamanio1=this.response[0].arreglo;
                let firts_flag=0;

                for(let j=0; j< flag_tamanio1.length; j++){
                  if(flag_tamanio1[j].description.length > 0 && flag_tamanio1[j].practice.length > 0){
                    firts_flag++;
                  }
                }


                /*if(firts_flag == flag_tamanio1.length){

                  if(this.response.length>1){
                    let flag_tamanio2=this.response[1].arreglo;
                    let second_flag=0;



                  }else{
                    this.aletaRestric('FORALL.COMPLETAR',true);
                    //return true;
                  }

                }else{
                  this.aletaRestric('FORALL.NADA_TRA',null,'warning');
                }
                */
                // fin información
              }, error => {
                console.log("error", error);
            });

            // fin prueba


        }else{
          this.aletaRestric('FORALL.NADA',null,'warning');
        }


    }, error => {
      console.log("error", error);
    })
  }


  private filterArray(dato:string){

    let aux = this.translateGet.length;
     for (let j = 0; j < aux; j++) {

        if(this.translateGet[j]['idioma'] == dato){
          return j;
        }
      }
      return null;
  }

  formvalido(status:boolean){
    this.practicasLlenas = status;
  }


  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }
  // aletaRestric(mensaje:string,confirmar?:boolean){
  //
  //     let infoModal: adverModal = {'tipo': 3, 'confirma': confirmar, 'mensaje': mensaje, 'diccionario': 'WIZARD.CERTIFICAR.'};
  //     const confirmaMod = this.dialog.open(ModalComponent, { data:infoModal });
  //
  //     if(confirmar){
  //       confirmaMod.afterClosed().subscribe(resultado => {
  //         if(resultado){
  //           this.forallService.guardaStatusForAll(this.productoCertificar.fechaCertificar).subscribe( (data: backInter.RespuestaGen) => {
  //             if(data.message == '212'){
  //               this.aletaRestric('FORALL.'+data.message);
  //               this.pasoCompleto = true;
  //               this.enviaOrdenWizard();
  //             };
  //           });
  //         }
  //       });
  //     }
  //
  // }
  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          this.forallService.guardaStatusForAll(parseInt(localStorage.getItem('fechaProducto'))).subscribe( (data: backInter.RespuestaGen) => {
            if(data.message == '212'){
              this.aletaRestric('FORALL.'+data.message,null,'success');
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      let tipoMsg: any = tipo;
      Swal.fire({
        title: texto,
        icon: tipoMsg,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }

  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      
      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }

}
